(function () {
    'use strict';

    var OutlineViewControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/outline-view.html',
        controllerAs: 'vm',
        bindings: {
            page: '<',
            propertyValue:'<',
            pictureType:'<',
            contourWidth: '<',
            onChange: '&'
        },
        controller: ['$scope', 'ImageService', '$timeout', 'Qinius', 'QiniuToken', 'MessageService', 'UidService', 'FontXmlsManger', 'ClipArt', 'RecommendPics', '$stateParams', '$translate', '$filter','$http','ImgprocContours', '$q',
            function ($scope, ImageService, $timeout, Qinius, QiniuToken, MessageService, UidService, FontXmlsManger, ClipArt, RecommendPics, $stateParams, $translate, $filter, $http, ImgprocContours, $q) {
                var vm = this;
                vm.page = angular.copy(vm.page);
                vm.page.background = null;
                vm.errorImage = null;
                vm.contourWidth = Number(vm.contourWidth || 0);
                if(vm.page.levels.level && vm.page.levels.level.length > 0){
                    vm.page.levels.level = vm.page.levels.level.filter(function(item){
                        return item.imagebox
                    });
                    if(!vm.page.levels.level.length){
                        MessageService[vm.isMobile ? 'hint' : 'error']($translate.instant('outline.message.noImageBox'));
                        vm.onChange();
                        return false;
                    }
                    for(var i=0;i<vm.page.levels.level.length;i++){
                        var imagebox = vm.page.levels.level[i].imagebox;
                        if(!imagebox.image || !imagebox.image.resource || !imagebox.image.resource.identifier){
                            MessageService[vm.isMobile ? 'hint' : 'error']($translate.instant('outline.message.blankImageBox'));
                            vm.onChange();
                            return false;
                        }
                    }
                }else{
                    MessageService[vm.isMobile ? 'hint' : 'error']($translate.instant('outline.message.blankPage'));
                    vm.onChange();
                    return false;
                }
                vm.width = PxTurnMm(vm.page.mediabox.width);
                vm.height = PxTurnMm(vm.page.mediabox.height);
                vm.threeLoading=false;
                vm.threeLoadingText = $translate.instant('outline.loading.generating');
                $scope.domain = Qinius.getDomain();
                vm.token = QiniuToken.getPromise('tokenWithPolicy', {"mimeLimit":"image/jpeg;image/png"});
                var userAgent = navigator.userAgent || navigator.vendor || window.opera;
                // 移动设备判断关键字
                vm.isMobile = /iPad|iPhone|iPod|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/.test(userAgent);
                vm.scale = 1;
                vm.scale1 = 1;
                vm.thumbnailScale = 1;
                vm.windowWidth = vm.isMobile ? 343 : 600;
                if (vm.page.mediabox.width > vm.page.mediabox.height) {
                    vm.scale = vm.windowWidth / vm.page.mediabox.width;
                } else {
                    vm.scale = vm.windowWidth / vm.page.mediabox.height;
                }
                vm.windowWidth1 = vm.isMobile ? 260 : 360;
                if (vm.page.mediabox.width > vm.page.mediabox.height) {
                    vm.scale1 = vm.windowWidth1 / vm.page.mediabox.width;
                } else {
                    vm.scale1 = vm.windowWidth1 / vm.page.mediabox.height;
                }
                
                $q.all([$scope.domain.$promise, vm.token.$promise]).then(function () {
                    vm.token = vm.token.token;
                    $scope.domain = 'https://' + $scope.domain.domains[0] + '/';
                    $scope.page = vm.page;
                    $scope.page.notTrimbox = true;
                    if($scope.page.outline && $scope.page.outline.contourWidth >= 0){
                        vm.contourWidth = $scope.page.outline.contourWidth || 0;
                    }
                    if(!$scope.page.outline){
                        vm.threeLoading=true;
                        thumbnailInit(function(url){
                            generateContour(url);
                        })
                    }
                });
                function generateContour(url){
                    ImgprocContours.generateContour({
                        "page": {
                            "front": url  // 必填，图像URL或base64数据
                        },
                        "pageSize": {          // 可选，期望输出尺寸（毫米）
                            "width": vm.width,
                            "height": vm.height
                        },
                        "contourWidth": Number(vm.contourWidth),   // 可选，描边宽度（毫米），默认2.0
                        "smoothFactor": 5,      // 可选，平滑因子，默认0
                        "mirrorable": vm.pictureType === 'spread'
                    },function(res){
                        if(res && res.data){
                            res.data.image = url;
                        }
                        imgprocSuccess(res,'cutline');
                    },imgprocError)
                }
                function imgprocSuccess(res,type) {
                    vm.threeLoading=false;
                    if(res.success){
                        if(res.data && res.data.success){
                            $scope.page.outline = {
                                type: type,
                                contourWidth: vm.contourWidth,
                                geometry: res.data.mmRect,
                                mask:{
                                    resource:{
                                        identifier: res.data.contourMask
                                    }
                                },
                                cutline:{
                                    resource:{
                                        identifier: res.data.contourUrl
                                    },
                                    color: vm.propertyValue.spotColor,
                                    colorValue: vm.propertyValue.color
                                }
                            }
                            if(res.data.mirror){
                                $scope.page.outlineSpread = {
                                    type: type,
                                    contourWidth: vm.contourWidth,
                                    geometry: res.data.mirror.mmRect,
                                    mask:{
                                        resource:{
                                            identifier: res.data.mirror.contourMask
                                        }
                                    },
                                    cutline: {
                                        resource:{
                                            identifier: res.data.mirror.contourUrl
                                        },
                                        color: vm.propertyValue.spotColor,
                                        colorValue: vm.propertyValue.color
                                    }
                                }
                            }
                        }else{
                            vm.errorImage = res.data;
                        }
                    }else{
                        MessageService[vm.isMobile ? 'hint' : 'error'](res.error);
                    }
                }
                function imgprocError(err) {
                    if($scope.page.outline && $scope.page.outline.contourWidth >= 0){
                        vm.contourWidth = $scope.page.outline.contourWidth;
                    }
                    vm.threeLoading=false;
                    MessageService[vm.isMobile ? 'hint' : 'error'](err.data.error || $translate.instant('outline.message.generationFailed'));
                }
                //生成封面图
                function thumbnailInit(callback) {
                    $timeout(function () {
                        html2canvas_adapt(document.getElementById('thumbnail-outline'), {
                            onrendered: function (canvas) {
                                if(canvas){
                                    QiniuToken.uploadThumbnail(canvas, function (data) {
                                        callback($scope.domain + data.key)
                                    }, function () {
                                        callback()
                                    }, 'tokenWithPolicy', {"mimeLimit":"image/jpeg;image/png"});
                                }else{
                                    callback()
                                }
                            },
                            error:function(){
                                callback()
                            },
                            letterRendering: true,
                            useCORS: true,
                            width: $scope.page.custom.width * vm.thumbnailScale,
                            height: $scope.page.custom.height * vm.thumbnailScale,
                            windowWidth: document.body.scrollWidth,
                            windowHeight: document.body.scrollHeight,
                            x: 0,
                            y: 0,
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            dpi:300
                        });
                    })
                }
                $scope.resetOutline = function () {
                    $scope.page.outline = null;
                    $scope.page.outlineSpread = null;
                    vm.threeLoading=true;
                    thumbnailInit(function(url){
                        generateContour(url,'cutline');
                    })
                }
                $scope.removeOutline = function () {
                    $scope.page.outline = null;
                    $scope.page.outlineSpread = null;
                }
                window.updatePicOutline = function ($event) {
                    $timeout(function () {
                        vm.errorImage = null;
                        var file = $event.target.files[0]; // 获取上传的文件
                        if (!file.type.startsWith('image/png')) {
                            if(vm.isMobile){
                                MessageService.hint($translate.instant('outline.message.invalidFormat', {fileType: file.type, serviceType: $filter('serviceType')(vm.type)}));
                            }else{
                                MessageService[vm.isMobile ? 'hint' : 'error']($translate.instant('outline.message.invalidFormat', {fileType: file.type, serviceType: $filter('serviceType')(vm.type)}));
                            }
                            return;
                        }
                        vm.threeLoading=true;
                        vm.threeLoadingText = $translate.instant('outline.loading.uploading');
                        ImageService.backendUploadPics(file, $scope.domain, vm.token, function(data){
                            if(data && data.key){
                                ImgprocContours.parseContour({
                                    "page": {
                                        "contour": $scope.domain + data.key
                                    },
                                    "pageSize": {          // 可选，期望输出尺寸（毫米）
                                        "width": vm.width,
                                        "height": vm.height
                                    },
                                    "contourWidth": vm.contourWidth,   // 可选，描边宽度（毫米），默认2.0
                                    "smoothFactor": 5,      // 可选，平滑因子，默认0
                                    "mirrorable": vm.pictureType === 'spread'
                                },function(res){
                                    if(res && res.data){
                                        res.data.image = $scope.domain + data.key
                                    }
                                    imgprocSuccess(res,'customized');
                                },imgprocError)
                            }else{
                                vm.threeLoading=false;
                                MessageService[vm.isMobile ? 'hint' : 'error']($translate.instant('outline.message.uploadFailed'));
                                $scope.$apply();
                            }
                        },function(err){
                            vm.threeLoading=false;
                            MessageService[vm.isMobile ? 'hint' : 'error']($translate.instant('outline.message.uploadFailed'));
                            $scope.$apply();
                        })
                    })
                };
                var outlineWidthDebounce;
                vm.changeOutlineWidth = function () {
                    var contourWidth = Number(vm.contourWidth);
                    if (!$scope.page || contourWidth < 0 || contourWidth > 5 || isNaN(contourWidth)) {
                        return;
                    }
                    if (outlineWidthDebounce) {
                        $timeout.cancel(outlineWidthDebounce);
                    }
                    outlineWidthDebounce = $timeout(function () {
                        vm.threeLoading = true;
                        thumbnailInit(function(url){
                            generateContour(url);
                        });
                    }, 500);
                };
                $scope.modalHide = function () {
                    vm.onChange();
                }
                $scope.save = function(){
                    vm.onChange({text:$scope.page});
                }
            }]
    };

    angular.module('editorApp')
        .component('outlineView', OutlineViewControl);

})();
